import { FONT_FAMILIES } from '@/constant';
import { SlideComponentMC } from '@/types/slide';
import { SlideComponentCreator } from './factory';

export class SlideComponentMCCreator extends SlideComponentCreator {
    public create(id: string): SlideComponentMC {
        return {
            id: id,
            pos: {
                x: 0,
                y: 484,
            },
            size: {
                width: 1024,
                height: 284,
            },
            type: 'mc',
            content: {
                answers: [
                    {
                        id: crypto.randomUUID(),
                        type: 'text',
                        pos: {
                            x: 0,
                            y: 0,
                        },
                        size: {
                            width: 0,
                            height: 0,
                        },
                        settings: {
                            backgroundColor: '#DADEE7',
                            isAnswer: true,
                        },
                        content: {
                            text: '',
                            fontSize: 16,
                            jyutping: [],
                            color: '#000000',
                            typeSettings: {
                                fontFamily: FONT_FAMILIES[0]?.fontFamily || 'Noto Sans SC',
                                formatting: [],
                                alignment: 'left',
                                isPhonetic: false,
                                borderRadius: 0,
                                backgroundColor: 'transparent',
                            },
                        },
                    },
                    {
                        id: crypto.randomUUID(),
                        type: 'text',
                        pos: {
                            x: 0,
                            y: 0,
                        },
                        size: {
                            width: 0,
                            height: 0,
                        },
                        settings: {
                            backgroundColor: '#DADEE7',
                            isAnswer: false,
                        },
                        content: {
                            text: '',
                            fontSize: 16,
                            jyutping: [],
                            color: '#000000',
                            typeSettings: {
                                fontFamily: FONT_FAMILIES[0]?.fontFamily || 'Noto Sans SC',
                                formatting: [],
                                alignment: 'left',
                                isPhonetic: false,
                                borderRadius: 0,
                                backgroundColor: 'transparent',
                            },
                        },
                    },
                    {
                        id: crypto.randomUUID(),
                        type: 'text',
                        pos: {
                            x: 0,
                            y: 0,
                        },
                        size: {
                            width: 0,
                            height: 0,
                        },
                        settings: {
                            backgroundColor: '#DADEE7',
                            isAnswer: false,
                        },
                        content: {
                            text: '',
                            fontSize: 16,
                            jyutping: [],
                            color: '#000000',
                            typeSettings: {
                                fontFamily: FONT_FAMILIES[0]?.fontFamily || 'Noto Sans SC',
                                formatting: [],
                                alignment: 'left',
                                isPhonetic: false,
                                borderRadius: 0,
                                backgroundColor: 'transparent',
                            },
                        },
                    },
                    {
                        id: crypto.randomUUID(),
                        type: 'text',
                        pos: {
                            x: 0,
                            y: 0,
                        },
                        size: {
                            width: 0,
                            height: 0,
                        },
                        settings: {
                            backgroundColor: '#DADEE7',
                            isAnswer: false,
                        },
                        content: {
                            text: '',
                            fontSize: 16,
                            jyutping: [],
                            color: '#000000',
                            typeSettings: {
                                fontFamily: FONT_FAMILIES[0]?.fontFamily || 'Noto Sans SC',
                                formatting: [],
                                alignment: 'left',
                                isPhonetic: false,
                                borderRadius: 0,
                                backgroundColor: 'transparent',
                            },
                        },
                    },
                ],
            },
        };
    }
}
